"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CALENDAR_MAX_VISIBLE_SOURCES = void 0;
/** Maximum number of calendar sources rendered in one aggregate Calendar. */
exports.CALENDAR_MAX_VISIBLE_SOURCES = 5;
